import Container from "@mui/material/Container";
import DataTable from "./DataTable";
import React from "react";
import CommonLayout from "../Common/Layout";

const UserManagement = () => {
  const breadcrumbArr = [{ link: "#", displayName: "Users", active: true }];

  return (
    <CommonLayout title="Users" breadcrumbArr={breadcrumbArr}>
      <Container maxWidth="false" sx={{ mt: 0, mb: 4, mx: 0 }}>
        <DataTable />
      </Container>
    </CommonLayout>
  );
};

export default UserManagement;
